<script setup>
import { watch, ref } from 'vue';
import { Line } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, PointElement, LineElement } from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, PointElement, LineElement);

const props = defineProps(['chartData','chartType', 'chartOptions']);
const chartDatas = ref({
  labels: [],
  datasets: [
    {
      label: '',
      data: []
    }
  ]
});

watch([() => props.chartData], () => {
    chartDatas.value = {
        labels: props.chartData.labels,
        datasets: props.chartData.datasets
    }
})

</script>
<template>
  
    <div class="fv-chart">
      
      <Line :data="chartDatas" height="100%" width="100%" :options = "chartOptions"/>
    </div>
</template>